import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from "../../services/translate.service";
import { LightIconButtonComponent } from '../buttons/light-icon-button-component';
import { Location, NgIf } from '@angular/common';
import { LoadingSpinnerComponent } from '../ui/loading-spinner-component';
import { CircleButtonComponent } from "../buttons/circle-button.component";
import { PageButtonComponent } from "../buttons/page-button.component";
import { BorderIconButtonComponent } from "../buttons/border-icon-button.component";

@Component({
  selector: 'app-payment-failed',
  standalone: true,
  templateUrl: './payment-failed.component.html',
  imports: [
    CircleButtonComponent,
    BorderIconButtonComponent
]
})
export class PaymentFailedComponent implements OnInit, OnDestroy {
  origin?: string = undefined;

  constructor(
    private router: Router,
    protected translate: TranslateService,
    private route: ActivatedRoute,
    private location: Location,
  ) { }

  ngOnInit(): void {
    this.origin = this.route.snapshot.data['origin'];
    const currentRoute = this.router.url;
    // or: const currentRoute = this.location.path();
    this.location.replaceState(currentRoute);
  }

  ngOnDestroy(): void {
  }

  private goToOrigin() {
    console.log(`origin: ${this.origin}`);
    const venueId = this.route.parent?.snapshot.params['venue_id'];
    if (this.origin === undefined) {
      this.router.navigate(['/', venueId], { replaceUrl: true });
      return;
    }
    // A failed payment link payment goes back to the link, not to the table bill (which may be empty)
    const plKey = this.route.snapshot.queryParamMap.get('pl');
    if (this.origin === 'livesplit' && plKey) {
      this.router.navigate(['/', venueId, 'pl', plKey], { replaceUrl: true });
      return;
    }
    this.router.navigate(['/', venueId, this.origin], { replaceUrl: true });
  }

  retryPayment(){
    this.goToOrigin();
  }

  back(){
    this.goToOrigin();
  }

  getString(s: string, pc: string = "normal") {
    return this.translate.single(s, pc);
  }

}
